var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiners(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 22,
    viewBox: "0 0 32 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "diners-fbcbd3360f8e3f629cdaa80e93abdb8b.svg",
    clipPath: "url(#clip0_999_909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 319
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card-Brands"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Diners-Club"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shape",
    d: "M29.3927 21.0553L29.3955 21.0553C30.6359 21.066 31.6536 20.0518 31.6691 18.788L31.6691 3.2058C31.6641 2.59459 31.4208 2.01078 30.9934 1.58301C30.567 1.15633 29.9923 0.919803 29.3927 0.924897L3.42208 0.924885C2.82524 0.919803 2.25053 1.15633 1.82415 1.58301C1.39669 2.01078 1.15342 2.59459 1.14845 3.20315L1.14844 18.7744C1.15342 19.3856 1.39669 19.9694 1.82415 20.3972C2.25053 20.8239 2.82524 21.0604 3.42484 21.0553H29.3927ZM29.3913 21.7047L29.3899 21.7047L29.3927 21.7047H29.3913Z",
    fill: "white",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 0.649375
  }), /*#__PURE__*/React.createElement("path", {
    id: "shape_2",
    d: "M13.8136 3.26492V3.24414H19.0086V3.26492C23.0808 3.5629 26.2324 6.95361 26.2324 11.0366C26.2324 15.1197 23.0808 18.5104 19.0086 18.8084V18.8291H13.8136V18.8084C9.74149 18.5104 6.58984 15.1197 6.58984 11.0366C6.58984 6.95361 9.74149 3.5629 13.8136 3.26492Z",
    fill: "#0165AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "shape_3",
    d: "M15.8901 15.4421C17.7542 14.7793 18.9994 13.0151 18.9994 11.0367C18.9994 9.05832 17.7542 7.29408 15.8901 6.63134V15.4421ZM12.7731 6.63134C10.909 7.29408 9.66386 9.05832 9.66386 11.0367C9.66386 13.0151 10.909 14.7793 12.7731 15.4421V6.63134ZM14.3316 17.7902C10.6018 17.7902 7.57812 14.7666 7.57812 11.0367C7.57812 7.30685 10.6018 4.2832 14.3316 4.2832C18.0615 4.2832 21.0851 7.30685 21.0851 11.0367C21.0851 14.7666 18.0615 17.7902 14.3316 17.7902Z",
    fill: "white"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_999_909"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.17,
    height: 20.78,
    fill: "white",
    transform: "translate(0.824219 0.600098)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiners);
export default __webpack_public_path__ + "static/media/Diners.034e849ab834dce0ce9438aaeecad6d5.svg";
export { ForwardRef as ReactComponent };